import React from 'react'

const ChatContext = React.createContext(null)

export default ChatContext